<template>
  <div :style="{ backgroundImage: `url(${background_image_url})`, color: text_color }" class="featured_preview">
    <img :src="image_url" class="mb-4">
    <strong class="mt-4">{{ title }}</strong><br>
    <div class="description" v-html="description"></div>
    <div class="listen_now" v-if="listen_now">
      <span class="c-avatar rounded-circle playbutton"><strong> > </strong></span>
      {{ listen_now }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeaturedPreview',
  props: {
    image_url: { type: String, default: null },
    background_image_url: { type: String, default: null },
    title: { type: String, default: '' },
    text_color: { type: String, default: '' },
    description: { type: String, default: '' },
    listen_now: { type: String, default: '' },
  },
}
</script>

<style>
.featured_preview {
  width:  375px;
  margin-top: 6px;
  aspect-ratio:  5.5 / 9;
  padding: 24px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  font-family: "Times New Roman", Times, serif;
  font-size: 18px;
  line-height:  24px;
  overflow:  hidden;
}
.featured_preview img {
  aspect-ratio:  1 / 1;
  display: block;
  width: 80%;
  margin-top:  40px;
  margin-left: auto;
  margin-right: auto;
}
.featured_preview .description {
  overflow: hidden;
  height: 30%;
  border-bottom: 1px dotted red;
}
.featured_preview .listen_now {
  margin-top: 16px;
  width: 75%;
  height: 42px;
  overflow: hidden;
}
.featured_preview .playbutton {
  color:  black;
  background-color: white;
}

</style>

